import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./ticker.module.scss";
import { useState } from "react";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const Ticker = ({ items = [], animationDuration = 30, tickerItemClassName = "" }: any) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={formatClassNames(isHovered && styles.paused, styles.tickerWrapper)}
      >
        <div
          className={styles.tickerContent}
          style={{ ...(animationDuration && { animationDuration: `${animationDuration}s` }) }}
        >
          {items.map((item: any, index: number) => (
            <span
              key={index}
              className={formatClassNames(
                styles.tickerItem,
                tickerItemClassName && tickerItemClassName,
              )}
            >
              {item}
            </span>
          ))}
          {items.map((item: any, index: number) => (
            <span
              key={index}
              className={formatClassNames(
                styles.tickerItem,
                tickerItemClassName && tickerItemClassName,
              )}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};
export default wrapperHOC(Ticker, {
  componentName: "Ticker-Home",
  showForChina: true,
});
